import { createSelector } from 'reselect';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';
import { USER_ROLES_DICTIONARY } from '../../consts/dictionaries';

const isLoadingSelector = (statusKey) => (state) => state.users[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

const isLoadingOrIdleSelector = (statusKey) => (state) => {
  const status = state.users[statusKey];
  return status === REDUX_ASYNC_STATUSES.LOADING || status === REDUX_ASYNC_STATUSES.IDLE;
};

export const selectUsers = (state) => state.users?.users;

export const selectGetUsersLoading = isLoadingOrIdleSelector('getUsersStatus');
export const selectCreateUserLoading = isLoadingSelector('createUserStatus');
export const selectUpdateUserLoading = isLoadingSelector('updateUserStatus');
export const selectDeleteUserLoading = isLoadingSelector('deleteUserStatus');

export const selectBulkEditUsersLoading = isLoadingSelector('bulkEditUsersStatus');

export const selectUserRoleOptions = createSelector([(state) => state.users?.userRoles], (roles = []) => {
  const rolesWithLabels = roles.map((role) => ({
    value: role,
    label: USER_ROLES_DICTIONARY[role] ?? role
  }));

  const sortedRoles = rolesWithLabels.sort((a, b) => a.label.localeCompare(b.label, 'de'));

  return sortedRoles;
});
